import {CompanyModel} from '../models/api/companyModel';
import {ApiTopic} from '../models/api/topicModel';
import {postApiAsync} from './http/http';

/** Create a new topic on the server. */
export function createTopicAsync(company: CompanyModel, name: string, link: string, type: string) {
  const url = `${company.url}/topics`;
  const requestBody = {
    name,
    ext_link: link,
    type,
  };
  return postApiAsync(ApiTopic, url, requestBody);
}
